import { render } from "./SegmentedController.vue?vue&type=template&id=65d0bdb2&scoped=true&ts=true"
import script from "./SegmentedController.vue?vue&type=script&lang=ts"
export * from "./SegmentedController.vue?vue&type=script&lang=ts"

import "./SegmentedController.vue?vue&type=style&index=0&id=65d0bdb2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d0bdb2"]])

export default __exports__